import React, { useContext, useState, useEffect } from "react";
import AdminContext from "../AdminDashContext";
import moment from "moment";
import { useFormik } from "formik";
import * as yup from "yup"
import axios from "axios"
import "./communicate.css";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import {faUser} from '@fortawesome/free-solid-svg-icons';
export default function CommunicateFarmers() {
  const {adminData, handleSendMessage,allFarmers,baseUrl,setAllFarmers} = useContext(AdminContext)
    const [chatMessages, setChatMessages] = useState([]);
  const [selectedUser, setSelectedUser] = useState("");  
 
  const ensureUniqueFarmer=()=>{
   if(allFarmers.length>0){
    const requiredFarmers=allFarmers.flatMap(farmer=>farmer);    
    const uniqueFarmers=[...new Set(requiredFarmers.map(farmer=>farmer.username))].map(username=>requiredFarmers.find(farmer=>farmer.username===username))
    setAllFarmers(uniqueFarmers);
   }

  }
  useEffect(()=>{
    ensureUniqueFarmer()
  },[])
    useEffect(() => {
      
    if (adminData?.username && selectedUser) {
      axios.get(`${baseUrl}/messages/${adminData?.username}/${selectedUser}`)
        .then(res => {          
          let filteredMessages=res?.data?.Response
          setChatMessages(filteredMessages);
        })
        .catch(error => {
          console.error("An error occurred fetching messages", error);
        });
    }
  }, [adminData?.username, selectedUser]);

  useEffect(() => {
    if (selectedUser.length > 0) {
      formik.setFieldValue("recipient", selectedUser);
    }
  }, [selectedUser]);

  const formik = useFormik({
    initialValues: {
      sender: adminData?.username,
      recipient: selectedUser,
      text: ""
    },
    validationSchema: yup.object().shape({
      text: yup.string("Text should be a string").required("Text is required").typeError("Text should be a string"),
      sender:yup.string("Sender shoul contain a value").required("Sender is required").typeError("Sender should be a string"),
     recipient:yup.string("Recipient should be a string").required("Recipient is required").typeError("Recipient should be a strng")
    }),
    onSubmit: async (values, { setSubmitting }) => {
      try {
        const newMessage = { ...values, timestamp: new Date().toISOString() };
        await handleSendMessage(newMessage);
        setChatMessages(prevMessages => [...prevMessages, newMessage]);
        formik.resetForm();
      } catch (error) {
        console.error("An error occurred sending messages", error);
      } finally {
        setSubmitting(false);
      }
    }
  });

  const handleSelectUser = (e) => {
    setSelectedUser(e.target.value);
  };

  const groupMessagesByDate = (messages) => {
    return messages.reduce((acc, msg) => {
      // Convert UTC to local time for display
      const localDate = moment.utc(msg.timestamp).local().format("YYYY-MM-DD");
      if (!acc[localDate]) {
        acc[localDate] = [];
      }
      acc[localDate].push(msg);
      return acc;
    },{});
  };

  const groupedMessages = groupMessagesByDate(chatMessages);

  return (
    <div className=" mb-16">
      {allFarmers ? (
        <div>
          <form>
            <select onChange={handleSelectUser} className="block w-full p-2 border border-gray-300 rounded">
              <option>Select a farmer</option>
              {allFarmers.map((farmer) => (
                <option value={farmer?.username} key={farmer?.id}>{farmer?.username}</option>
              ))}
            </select>
          </form>
        </div>
      ) : (
        <p>Sorry, no farmer to communicate with</p>
      )}
      {selectedUser.length > 0 && (
        <div className="flex flex-col flex-grow border rounded shadow-lg bg-white  mt-4 mb-10">
          <div className="flex-grow overflow-y-auto p-4">
            {Object.keys(groupedMessages).length > 0 ? (
              Object.entries(groupedMessages).map(([date, messages], dateIndex) => (
                <div key={dateIndex}>
                  <div className="text-center text-gray-500 mb-2">
                    {moment.tz(date, moment.tz.guess()).format("YYYY-MM-DD")}
                  </div>
                  {messages.map((msg, index) => (
                    <div
                      key={index}
                      className={`mb-2 p-2 rounded max-w-fit  min-w-fit ${msg.sender === adminData?.username
                          ? "ml-auto bg-green-100"
                          : "mr-auto bg-gray-200"
                        }`}
                      style={{
                        alignSelf: msg.sender === adminData?.username ? 'flex-end' : 'flex-start',
                      }}
                    >
                      <div className=" flex flex-row justify-between ">
                        <p className=" mr-10">{msg.text}</p>
                        <FontAwesomeIcon icon={faUser}/>
                      </div>
                      <div className="text-sm text-gray-600 flex justify-between">
                        <span className=" mr-10">{msg.sender === adminData?.username ? "You" : msg.sender}</span>
                        <span>{moment.utc(msg.timestamp).local().format("LT")}</span> {/* Convert to local time */}
                      </div>
                    </div>
                  ))}
                </div>
              ))
            ) : (
              <p className="text-center text-gray-500">
                No messages yet. Start the conversation!
              </p>
            )}
          </div>
          <form className="p-4 border-t flex items-center" onSubmit={formik.handleSubmit}>
            <input
              name="text"
              value={formik.values.text}
              onChange={formik.handleChange}
              className="flex-grow p-2 border rounded mr-2"
              placeholder="Type a message..."
            />
            <button
              type="submit"
              className="p-2 bg-blue-500 text-white rounded disabled:opacity-50"
              disabled={formik.isSubmitting || !formik.isValid}
            >
              Send
            </button>
          </form>
        </div>
      )}
    </div>
  );

}

